import React, { ReactNode } from 'react';
import { SpinnerWithText } from '../decorated-elements';
import './InteractionBlocker.css';

const InteractionBlocker = (props: {
  disableInteraction: boolean;
  children: ReactNode;
  overlayRenderer?: ReactNode;
  overlaySpinnerMessage?: string;
}) => {
  const classNames =
    'interaction-blocker-content-wrapper ' +
    (props.disableInteraction
      ? 'interaction-blocker-content-wrapper-faded'
      : '');
  return (
    <div className="interaction-blocker-container">
      <div className={classNames}>{props.children}</div>
      {props.disableInteraction && (
        <div
          className={`block-layer-below ${
            props.overlaySpinnerMessage ? 'has-spinner-message' : ''
          }`}
        >
          {props.overlayRenderer ? props.overlayRenderer : undefined}
          {props.overlaySpinnerMessage ? (
            <div className="spinner-wrapper-container">
              <SpinnerWithText size="sm">
                {props.overlaySpinnerMessage}
              </SpinnerWithText>
            </div>
          ) : (
            undefined
          )}
        </div>
      )}
    </div>
  );
};

export default InteractionBlocker;
